export const objectives = [
  "Build skills in fundamental concepts and practical approaches to SM&E of malaria programs",
  "Discuss programmatic applications of main tools and data systems used to monitor and evaluate malaria programs",
  "Provide a venue for participants to share and learn from other country experiences to strengthen their SM&E systems",
  "Create a network of SM&E alumni",
];
